export { ReactComponent as ArrowDownIcon } from 'assets/arrowDown.svg';
export { ReactComponent as BackIcon } from 'assets/back.svg';
export { ReactComponent as CartIcon } from 'assets/cart.svg';
export { ReactComponent as CloseIcon } from 'assets/close.svg';
export { ReactComponent as FilterIcon } from 'assets/filter.svg';
export { ReactComponent as LineIcon } from 'assets/line.svg';
export { ReactComponent as LogoIcon } from 'assets/logo.svg';
export { ReactComponent as MenuIcon } from 'assets/menu.svg';
export { ReactComponent as OrderIcon } from 'assets/order.svg';
export { ReactComponent as PhoneIcon } from 'assets/phone.svg';
export { ReactComponent as SeeMoreIcon } from 'assets/seeMore.svg';
export { ReactComponent as SmsIcon } from 'assets/sms.svg';
export { ReactComponent as UnCheckBoxIcon } from 'assets/unCheckBox.svg';

//toolbar
export { ReactComponent as AccountIcon } from 'assets/account.svg';
export { ReactComponent as CategoryIcon } from 'assets/category.svg';
export { ReactComponent as ContentHubIcon } from 'assets/content-hub.svg';
export { ReactComponent as ProductIcon } from 'assets/product.svg';

export { default as BgImage } from 'assets/background.jpg';
// export { default as SubmitHeroImage } from 'assets/submit-hero.png';
export const SubmitHeroImage =
  'https://d2zayvicus4xl7.cloudfront.net/tag-heuer-1-on-1/tag-heuer-bg-final.jpg';

// export { default as LoginLogoImage } from 'assets/login-logo.png';
export const LoginLogoImage =
  'https://d2zayvicus4xl7.cloudfront.net/tag-heuer-1-on-1/logo@3x.png';

// export { default as ClientBgImage } from 'assets/client-bg.jpg';
export const ClientBgImage =
  'https://d2zayvicus4xl7.cloudfront.net/tag-heuer-1-on-1/tag-heuer-bg.jpg';
